"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualTextAttributeSchema = void 0;
exports.ContextualTextAttributeSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContextualTextAttribute",
    "description": "Add a variation of an attribute for a specific context (e.g. if used in a social media context)",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:contextual"
            ]
        },
        "contexts": {
            "type": "object",
            "additionalProperties": false,
            "patternProperties": {
                "^rrn:content:ext:context:(social|seo|featured|epg)$": {
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                }
            }
        }
    },
    "required": [
        "contexts",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dHVhbC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2NvbnRleHR1YWwuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsS0FBSyxFQUFFLG1FQUFtRTtJQUMxRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx5QkFBeUI7SUFDbEMsYUFBYSxFQUFFLGlHQUFpRztJQUNoSCxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTix1QkFBdUI7YUFDeEI7U0FDRjtRQUNELFVBQVUsRUFBRTtZQUNWLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7WUFDN0IsbUJBQW1CLEVBQUU7Z0JBQ25CLHFEQUFxRCxFQUFFO29CQUNyRCxNQUFNLEVBQUUsNkRBQTZEO2lCQUN0RTthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFVBQVU7UUFDVixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=